import { useEffect, useState, RefObject } from "react";
import { BANNER_OFFSET_HIDE } from "constants/layout-consts";

/** Must match FestivalBanner height (`h-[56px]`). */
const FESTIVAL_BANNER_HEIGHT = 56;

/**
 * This hook listens to window scroll events and returns two boolean values:
 * - scrolled: whether the festival banner should be collapsed (same threshold as FestivalBanner).
 * - titleVisible: whether the page title should be visible based on the current scroll position.
 *
 * @param titleRef A reference to the element containing the page title.
 * @param breadcrumbRef A reference to the element containing the breadcrumb navigation.
 */
export const useScroll = (
  titleRef: RefObject<HTMLElement | null | undefined>,
  breadcrumbRef: RefObject<HTMLElement | null | undefined>
) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Keep in sync with FestivalBanner: hide when scrollY >= 500 + banner height.
      const bannerHidden =
        window.scrollY >= BANNER_OFFSET_HIDE + FESTIVAL_BANNER_HEIGHT;
      setScrolled(bannerHidden);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [titleRef, breadcrumbRef]);

  return { scrolled };
};
